import { Icon } from '@iconify/react/dist/iconify.js';
import React from 'react';
import useReactApexChart from '../../../../hook/useReactApexChart';

const fmt = (n) => (n ?? 0).toLocaleString('en-IN');

const Tile = ({ title, icon, iconBg, gradient, value, valueSuffix = '', delta, deltaSuffix = '', deltaPrefix = '+', chartColor, chartId, createChart }) => (
    <div className="col-xxl-4 col-sm-6">
        <div className={`card p-3 shadow-2 radius-8 border input-form-light h-100 ${gradient}`}>
            <div className="card-body p-0">
                <div className="d-flex flex-wrap align-items-center justify-content-between gap-1 mb-8">
                    <div className="d-flex align-items-center gap-2">
                        <span className={`mb-0 w-48-px h-48-px ${iconBg} flex-shrink-0 text-white d-flex justify-content-center align-items-center rounded-circle h6 mb-0`}>
                            <Icon icon={icon} className="icon" />
                        </span>
                        <div>
                            <span className="mb-2 fw-medium text-secondary-light text-sm">{title}</span>
                            <h6 className="fw-semibold">{value}{valueSuffix}</h6>
                        </div>
                    </div>
                    <div id={chartId} className="remove-tooltip-title rounded-tooltip-value">
                        {createChart(chartColor)}
                    </div>
                </div>
                <p className="text-sm mb-0">
                    Increase by{' '}
                    <span className="bg-success-focus px-1 rounded-2 fw-medium text-success-main text-sm">
                        {deltaPrefix}{delta}{deltaSuffix}
                    </span>{' '}
                    this week
                </p>
            </div>
        </div>
    </div>
);

const UnitCountTwo = ({ tiles }) => {
    const { createChart } = useReactApexChart();

    const t = tiles || {};
    const sa = t.totalSuperAdmins || {};
    const so = t.totalSocieties || {};
    const oc = t.totalOccupants || {};
    const te = t.totalTenants || {};
    const fl = t.totalFlats || {};
    const br = t.totalBrands || {};

    return (
        <div className="col-xxl-8">
            <div className="row gy-4">
                <Tile
                    title="Total Super Admins"
                    icon="mingcute:user-follow-fill"
                    iconBg="bg-primary-600"
                    gradient="bg-gradient-end-1"
                    value={fmt(sa.value)}
                    delta={fmt(sa.deltaThisWeek)}
                    chartColor="#487fff"
                    chartId="new-user-chart"
                    createChart={createChart}
                />
                <Tile
                    title="Total Societies"
                    icon="mdi:building"
                    iconBg="bg-success-main"
                    gradient="bg-gradient-end-2"
                    value={fmt(so.value)}
                    delta={fmt(so.deltaThisWeek)}
                    chartColor="#45b369"
                    chartId="active-user-chart"
                    createChart={createChart}
                />
                <Tile
                    title="Total Occupants"
                    icon="mdi:users"
                    iconBg="bg-purple"
                    gradient="bg-gradient-end-4"
                    value={fmt(oc.percentage)}
                    valueSuffix="%"
                    delta={fmt(oc.deltaPercentThisWeek)}
                    deltaSuffix="%"
                    chartColor="#8252e9"
                    chartId="conversion-user-chart"
                    createChart={createChart}
                />
                <Tile
                    title="Total Tenants"
                    icon="mdi:home-account"
                    iconBg="bg-yellow"
                    gradient="bg-gradient-end-3"
                    value={fmt(te.value)}
                    delta={fmt(te.deltaThisWeek)}
                    chartColor="#f4941e"
                    chartId="total-sales-chart"
                    createChart={createChart}
                />
                <Tile
                    title="Total Flats"
                    icon="mdi:leads"
                    iconBg="bg-pink"
                    gradient="bg-gradient-end-5"
                    value={fmt(fl.value)}
                    delta={fmt(fl.deltaThisWeek)}
                    chartColor="#de3ace"
                    chartId="leads-chart"
                    createChart={createChart}
                />
                <Tile
                    title="Total Brands"
                    icon="mdi:badge-account-horizontal"
                    iconBg="bg-cyan"
                    gradient="bg-gradient-end-6"
                    value={fmt(br.value)}
                    delta={fmt(br.deltaThisWeek)}
                    chartColor="#00b8f2"
                    chartId="total-profit-chart"
                    createChart={createChart}
                />
            </div>
        </div>
    );
};

export default UnitCountTwo;
